import React from "react";
import { Link, useLocation } from "react-router-dom";

interface IBrandComponentProps {}

export const BrandComponent: React.FC<IBrandComponentProps> = () => {
    const location = useLocation();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (location.pathname === "/home") {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <Link
            to="/home"
            onClick={handleClick}
            className="logo d-flex align-items-center me-auto me-xl-0"
        >
            <img loading="lazy" src="/assets/img/iLogo.png" alt="italent-logo" />
        </Link>
    );
};
